import React from "react";
import LGWashingPageTemplate from "./LGWashingPageTemplate";

const relatedLinks = [
  { to: "/lg-appliance-service-bangalore", label: "LG Appliance Service" },
  { to: "/lg-washing-machine-service-bangalore", label: "LG Washing Machine Service" },
  { to: "/lg-washing-machine-repair-bangalore", label: "LG Washing Machine Repair" },
  { to: "/lg-washing-machine-not-working-repair", label: "LG Washing Machine Not Working Repair" },
  { to: "/lg-washing-machine-no-power-issue", label: "LG Washing Machine No Power Issue" },
];

const LGWashingMachineWaterLeakRepair = () => {
  return (
    <LGWashingPageTemplate
      title="LG Washing Machine Water Leak Repair in Bangalore"
      description="LG washing machine water leak repair in Bangalore for drain hose damage, inlet valve faults, loose connections, and seal issues."
      keywords="lg washing machine water leak repair, lg leakage service, lg washing machine repair bangalore"
      path="/lg-washing-machine-water-leak-repair"
      bannerTitle="LG Washing Machine Water Leak Repair"
      intro={<><span style={{ fontWeight: 'bold' }}>Water leaking</span> from an LG washing machine can damage flooring and interrupt daily use. Our Bangalore service team checks hoses, inlet valves, door seals, drain lines, and internal fittings to stop leakage and restore safe operation.</>}
      highlights={[
        "Leak inspection for hoses and drain lines",
        "Door seal and inlet valve checks",
        "Internal pipe and connection diagnosis",
        "Repair support for repeat leakage complaints",
      ]}
      issues={[
        "Water leaking from the bottom",
        "Door seal leakage",
        "Drain pipe overflow",
        "Loose internal connection leaks",
      ]}
      relatedLinks={relatedLinks}
    />
  );
};

export default LGWashingMachineWaterLeakRepair;
